import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import PublicRoute from "./components/PublicRoute";
import AndroidBackButton from "./components/AndroidBackButton";
import RootRedirect from "./components/RootRedirect";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Visits, { NewVisit } from "./pages/Visits";
import Expenses, { NewExpense } from "./pages/Expenses";
import Distributors, { DistributorForm } from "./pages/Distributors";
import Outlets, { OutletForm } from "./pages/Outlets";
import Attendance from "./pages/Attendance";
import DeviceAlerts from "./pages/DeviceAlerts";
import Masters from "./pages/Masters";
import UsersPage from "./pages/Users";
import Approvals from "./pages/Approvals";
import Reports from "./pages/Reports";
import Profile from "./pages/Profile";

// Orders, Damages and Price Groups are withdrawn in this pouch-milk-only version
// (KEYNOTES 2, 3, 4). The page components are left in the repo, unimported, so the
// modules can be switched back on without being rewritten.

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <AndroidBackButton />
        <Routes>
          {/* Public Routes - already signed in? straight to the dashboard. */}
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute><Dashboard /></ProtectedRoute>
          } />
          
          {/* Visits */}
          <Route path="/visits" element={
            <ProtectedRoute><Visits /></ProtectedRoute>
          } />
          <Route path="/visits/new" element={
            <ProtectedRoute><NewVisit /></ProtectedRoute>
          } />
          
          {/* Attendance - punch in / punch out (KEYNOTES 15, 16) */}
          <Route path="/attendance" element={
            <ProtectedRoute><Attendance /></ProtectedRoute>
          } />

          {/* Withdrawn modules - any bookmarked link lands back on the dashboard */}
          <Route path="/orders/*" element={<Navigate to="/dashboard" replace />} />
          <Route path="/damages/*" element={<Navigate to="/dashboard" replace />} />
          <Route path="/admin/price-groups/*" element={<Navigate to="/dashboard" replace />} />

          {/* Expenses */}
          <Route path="/expenses" element={
            <ProtectedRoute><Expenses /></ProtectedRoute>
          } />
          <Route path="/expenses/new" element={
            <ProtectedRoute><NewExpense /></ProtectedRoute>
          } />
          
          {/* Distributors */}
          <Route path="/distributors" element={
            <ProtectedRoute><Distributors /></ProtectedRoute>
          } />
          <Route path="/distributors/new" element={
            <ProtectedRoute><DistributorForm /></ProtectedRoute>
          } />
          <Route path="/distributors/:id/edit" element={
            <ProtectedRoute><DistributorForm /></ProtectedRoute>
          } />
          
          {/* Outlets */}
          <Route path="/outlets" element={
            <ProtectedRoute><Outlets /></ProtectedRoute>
          } />
          <Route path="/outlets/new" element={
            <ProtectedRoute><OutletForm /></ProtectedRoute>
          } />
          <Route path="/outlets/:id/edit" element={
            <ProtectedRoute><OutletForm /></ProtectedRoute>
          } />
          
          {/* Reports */}
          <Route path="/reports" element={
            <ProtectedRoute><Reports /></ProtectedRoute>
          } />
          
          {/* Profile */}
          <Route path="/profile" element={
            <ProtectedRoute><Profile /></ProtectedRoute>
          } />
          
          {/* Admin Routes */}
          <Route path="/masters" element={
            <ProtectedRoute adminOnly><Masters /></ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>
          } />
          <Route path="/approvals" element={
            <ProtectedRoute adminOnly><Approvals /></ProtectedRoute>
          } />
          <Route path="/device-alerts" element={
            <ProtectedRoute adminOnly><DeviceAlerts /></ProtectedRoute>
          } />

          {/* Default redirect - dashboard when signed in, login when not. */}
          <Route path="/" element={<RootRedirect />} />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
